import { render, staticRenderFns } from "./ChooseHotel.vue?vue&type=template&id=2d2c7ff9&scoped=true"
import script from "./ChooseHotel.vue?vue&type=script&lang=js"
export * from "./ChooseHotel.vue?vue&type=script&lang=js"
import style0 from "./ChooseHotel.vue?vue&type=style&index=0&id=2d2c7ff9&prod&lang=css"
import style1 from "./ChooseHotel.vue?vue&type=style&index=1&id=2d2c7ff9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2c7ff9",
  null
  
)

export default component.exports